import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { UploadFileTypes } from "../../constants";
import { usePayments } from "../../hooks";
import { Button } from "../buttons/Buttons";
import ImageUploadModal from "../modals/ImageUploadModal";
import ViewMediaModal from "../modals/ViewMediaModal";
import styles from "./Table.module.css";

function DebitsTable({ columns, data, title }) {
  const [tableData, setTableData] = useState(data);
  const columnCount = columns.length;

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  useEffect(() => {
    if (data) setTableData(data);
  }, [data]);

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction });

    const sortedData = [...tableData].sort((a, b) => {
      const parseValue = (value) =>
        typeof value === "string" && value.includes("₹") ? parseInt(value.replace(/₹|,/g, "")) : value;
      const aValue = parseValue(a[key]) ?? "";
      const bValue = parseValue(b[key]) ?? "";

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setTableData(sortedData);
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [paymentId, setPaymentId] = useState(null);

  const { updatePaymentProof } = usePayments();
  const handlePaymentScreenshotUpload = async (file_id, url) => {
    setShowImageUploadModal(false);
    const { success, error } = await updatePaymentProof(paymentId, { payment_proof_id: file_id });
    if (!success) return toast.error(error);
    toast.success(success);
    const updatedData = tableData.map((item) => {
      if (item.id === paymentId) {
        return { ...item, payment_proof: { id: file_id, url: url } };
      }
      return item;
    });
    setTableData(updatedData);
    // window.location.reload();
  };

  return (
    <>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={`${styles.table} ${styles[`table_${columnCount}`]}`}>
        <div className={styles.table_header}>
          {columns.map((column, index) => (
            <div key={index} className={styles.table_header_cell}>
              <span className={styles.table_header_name}>{column.name}</span>
              {column.id !== "action" && (
                <button className={styles.sort_btn} onClick={() => handleSort(column.id)}>
                  <Icon
                    icon="ri:arrow-drop-down-line"
                    inline
                    className={`${styles.sort_icon} ${
                      sortConfig.key === column.id && sortConfig.direction === "asc" ? styles.asc : styles.desc
                    }`}
                  />
                </button>
              )}{" "}
            </div>
          ))}
        </div>
        <div className={styles.table_body}>
          {tableData.length === 0 ? (
            <div className="row space-top small">No data added yet</div>
          ) : (
            tableData.map((row, index) => (
              <div key={index} className={styles.table_row}>
                {columns.map((column) => (
                  <div key={column.id} className={styles.table_body_cell}>
                    {column.id === "action" ? (
                      <div className="row">
                        {row.payment_proof.url ? (
                          <Button
                            className="ghost"
                            onClick={() => {
                              setShowImageModal(true);
                              setImageUrl(row.payment_proof.url);
                            }}
                          >
                            View
                          </Button>
                        ) : (
                          <span className="small gray">Image not uploaded</span>
                        )}
                        <Button
                          className="ghost"
                          onClick={() => {
                            setShowImageUploadModal(true);
                            setPaymentId(row.id);
                          }}
                        >
                          Upload
                        </Button>
                      </div>
                    ) : (
                      row[column.id] ?? "-"
                    )}
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
      {showImageModal &&
        createPortal(
          <ViewMediaModal
            isVisible={showImageModal}
            handleClose={() => {
              setShowImageModal(false);
              setImageUrl("");
            }}
            mediaType={UploadFileTypes.IMAGES}
            url={[imageUrl]}
            title="Payment Proof"
          />,
          document.body
        )}
      {showImageUploadModal &&
        createPortal(
          <ImageUploadModal
            isVisible={showImageUploadModal}
            handleClose={() => {
              setShowImageUploadModal(false);
              setImageUrl("");
            }}
            fileType={UploadFileTypes.IMAGES}
            title="Upload Payment Proof"
            handleUpload={handlePaymentScreenshotUpload}
          />,
          document.body
        )}
    </>
  );
}

export default DebitsTable;
